import mitt from 'mitt';
export function setupGlobalEmitter(isModal = false) {
    const emitter = mitt();
    if (!isModal && (window === null || window === void 0 ? void 0 : window.mediaCenterApp)) {
        window.mediaCenterApp.config.globalProperties.emitter = emitter;
    }
    else if (isModal && (window === null || window === void 0 ? void 0 : window.mediaCenterModalApp)) {
        window.mediaCenterModalApp.config.globalProperties.emitter = emitter;
    }
}
